export const getEditorKeyByNote = (editors, note) => {
    if (!editors || (typeof note === "object" && note.id === null)) {
        return undefined;
    }
    const targetId = typeof note === "object" ? note.id : note;
    for (const [key, ed] of Object.entries(editors)) {
        if (ed?.id === targetId) {
            return key;
        }
    }
    return undefined;
};
